import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { fetchInterpreters } from 'slices/interpreterSlice';
import { interpreterSelector } from 'slices/interpreterSlice';
import { Select, selectCustomStyles } from './Select';
import { AsyncPaginate } from 'react-select-async-paginate';

function SelectInterpreterModal({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
}) {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const { interpreter: interpreters, loader: loaderInterpreter } = useSelector(interpreterSelector);


    // React.useEffect(() => {
    //     // clearAllFields()
    //     Promise.allSettled(
    //         [
    //             dispatch(fetchInterpreters(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" })),
    //         ]
    //     );
    //     return () => {
    //     }
    // }, []);


    const filteredInterpreters = React.useMemo(() => {
        if (interpreters) {
            return interpreters?.map(interpreter => {
                const object = {
                    value: interpreter.id,
                    label: interpreter.first_name + " " + interpreter.last_name
                }
                return object
            })
        }
        else return []
    }, [interpreters]);

    const methods = useForm();
    const { setFocus, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, clearErrors } = methods



    useEffect(() => {

        methods.reset({ cancel_reason: '' })

    }, [isOpen])

    // #region interpreter dropdown

    const [interpreterState, setInterpreterState] = useState({})

    const filteredInterpretersLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchInterpreters(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result?.data?.map(item => ({
                value: item?.id,
                label: item?.first_name,
            })),
            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion

    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => {
                    setLoading(true);
                    onConfirm(data, "assign", ()=>{
                        setLoading(false);
                    })
                })}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">Assign Interpreter</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards step_1'>
                            <h2>Assign Interpreter</h2>
                            {/* <div className="row-primary">
                                <h2>Select Interpreter</h2>
                                <div className='w-100'>
                                    <Controller
                                        name="interpreter_id"
                                        control={control}
                                        rules={{
                                            required: "Please select a Interpreter"
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <Select
                                                    name="interpreter_id"
                                                    options={filteredInterpreters || []}
                                                    {...field}
                                                    loading={loaderInterpreter}
                                                    value={field.value ? filteredInterpreters?.find((opt) => field.value == opt.value) : null}
                                                    onChange={(value) => {
                                                        field.onChange(value);
                                                    }}
                                                />

                                                {errors?.interpreter_id?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.interpreter_id?.message} />
                                                    </div>
                                                }

                                            </div>
                                        }
                                    />
                                </div>
                            </div> */}
                            <div className="row-primary">
                                <h2>Select Interpreter</h2>
                                <Controller
                                    name="interpreter_id"
                                    control={control}
                                    rules={{
                                        required: "Please select a Interpreter"
                                    }}
                                    render={({ field }) =>
                                        <div style={{ width: "100%" }}>
                                            <AsyncPaginate
                                                menuPlacement='auto'
                                                styles={{
                                                    ...selectCustomStyles,
                                                }}
                                                value={interpreterState}
                                                loadOptions={filteredInterpretersLoadOptions}
                                                isClearable
                                                escapeClearsValue
                                                onChange={(obj) => {
                                                    setInterpreterState(obj);
                                                    field.onChange(obj?.value);
                                                }}
                                                additional={{
                                                    page: 1,
                                                }}
                                            />
                                            {errors?.interpreter_id?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.interpreter_id?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton btnText="Submit" disabled={loaderInterpreter} loader={loading}  />
                        <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                    </ModalFooter>
                </form>
            </Modal>
        </>
    );
}

export default SelectInterpreterModal;